<ng-container *transloco="let t;read: 'workers'">
  <div class="{{cssClass}}" *ngIf="visible">
    <div>
      <h3>{{t('addWorkers.'+labelName)}}<span *ngIf="requiredStar" class="text-danger">*</span></h3>
      <section
        class="dragdrop-box form-control d-flex flex-column text-center align-items-center gap-1 py-3 position-relative"
        (dragover)="onDragOver($event)" (dragleave)="onDragLeave($event)" (drop)="onDrop($event)">
        <input type="file" [id]="fileInput" (change)="uploadedFile($event)"
          [accept]="isZipOnly ? '.zip' : 'image/jpeg, image/png, image/jpg'" [multiple]="isMultiple" hidden />

        <label [for]="fileInput" class="img-label w-100 h-100 d-flex flex-column align-items-center">
          <img src="assets/images/imgg-cloud.svg" alt="Upload" class="upload-icon" width="32" height="32" />

          <p class="drag-drop-text">
            {{ t('addWorkers.dragDrop') }}
          </p>
          <p class="mb-0 file-info-text">
            {{ t('addWorkers.maximumFile') }}<br />
            {{ t('addWorkers.jpgPng') }}
          </p>
        </label>

      </section>
      <div *ngIf="uploadErrorMsg" class="alert alert-danger mt-2">
        {{ uploadErrorMsg }}
      </div>
    </div>
  </div>
</ng-container>
